import { markRaw } from 'vue'
import { defineStore } from 'pinia';
import { code } from '🔗/utils/utils';

const useModalsStore = defineStore('modals', {
    state: () => ({
        confirmSettings: null,
        modals: {},
        modalsComponents: {},
        openedModals: [],
        callbacks: {}
    }),
    getters: {
        lastIsQueue: (state) => {
            if (state.openedModals.length && 
                state.openedModals[state.openedModals.length - 1]?.quietClose
            ) {
                return true;
            }

            return false;
        },
        routeIsFrozen: (state) => !!state.openedModals.filter(item => item.popover === undefined || item.popover === false).length > 0 || state.confirmSettings !== null,
    },
    actions: {
        getData(name) {
            return this.openedModals.find((modal) => modal.name === name)?.data;
        },

        addCallback(payload) {
            if (!payload?.type || !payload.callback) {
                return
            }

            if (!this.callbacks[payload.type]) {
                this.callbacks[payload.type] = [];
            }

            const id = code();

            this.callbacks[payload.type].push({
                ...payload,
                id
            });

            return id;
        },
        removeCallback(id) {
            const ids = Object.keys(this.callbacks);
            if (!ids?.length) {
                return
            };

            ids.forEach(id => {
                const cb = this.callbacks[id]?.find(item => item.id === id);

                if (cb) {
                    this.callbacks[id].splice(this.callbacks[id].indexOf(cb), 1);
                }
            });
        },

        register(payload) {
            if (!payload || !Object.keys(payload)?.length) {
                return;
            }

            Object.keys(payload).forEach(id => {
                if (typeof(id) == 'function') {
                    this.modals[id] = payload[id];
                } else {
                    this.modals[id] = async () => payload[id];
                }
            });
        },

        unRegister(payload) {
            const items = typeof(payload) === 'string' ? [payload] : payload;

            // Закрываем, если открыто
            this.openedModals = this.openedModals.filter(item => items.indexOf(item.name) === -1);

            // Чистим
            items.forEach(id => {
                delete this.modalsComponents[id];
                delete this.modals[id];
            });
        },

        async open(name, payload) {
            if (this.openedModals.find((modal) => modal.name === name)) {
                return;
            }

            if (!this.modals[name]) {
                return;
            }

            if (!this.modalsComponents[name]) {
                this.modalsComponents[name] = markRaw(await this.modals[name]());
            }

            this.openedModals.push({
                name: name,
                data: payload?.data,
                quietClose: !!payload?.quietClose,
                popover: !!payload?.popover,
                callback: payload?.callback
            });
        },

        async reopen(name, payload) {
            this.close(name);
            setTimeout(async () => {
                await this.open(name, payload);
            });
        },

        close(name, data) {
            const modal = this.openedModals.find((modal) => modal.name === name);
            if (modal) {
                if (modal.callback) {
                    modal.callback(data);
                }
                this.openedModals.splice(this.openedModals.indexOf(modal), 1);
            }
        },

        closeAllQuiet() {
            const popover = this.openedModals?.filter(item => item.popover);
            const openedModals = this.openedModals?.filter(item => item.name !== 'loader');

            const check = () => {
                if (!openedModals.length || !openedModals[openedModals.length -1].quietClose) {
                    return;
                }

                openedModals.pop();
                check();
            }

            check();

            this.openedModals = [...openedModals, ...popover];

            if (this.callbacks['close-all-quiet']?.length) {
                this.callbacks['close-all-quiet'].forEach(item => item.callback && item.callback());
            }
        },

        back() {
            if (!this.openedModals?.filter(item => item.name !== 'loader' && !item.popover).length) {
               // Плеер свернем
                if (this.callbacks['back']?.length) {
                    if (this.callbacks['back'].some(item => item.callback && item.callback())) {
                        return true;
                    }
                }

                return;
            }

            // Модалки. Если есть что закрыть - закрываем
            if (this.openedModals.length && 
                this.openedModals[this.openedModals.length - 1]?.quietClose
            ) {
                this.openedModals.pop();
                return true;
            }

         

            // if (this.openedModals?.filter(item => item.name !== 'loader' && !item.popover).length) {
            //     const popover = this.openedModals?.filter(item => item.popover);
            //     // const popover = [this.openedModals?.filter(item => item.popover)];
            //     const openedModals = this.openedModals?.filter(item => item.name !== 'loader');

            //     if (openedModals[openedModals.length - 1]?.quietClose) {
            //         openedModals.pop();
            //         this.openedModals = [...openedModals, ...popover];
            //         // this.openedModals = [...openedModals, [...popover]];
            //     }

            //     return true;
            // }

            return false;
        },

        confirm(payload) {
            if (typeof payload == 'string') {
                payload = {
                    body: payload
                };
            }
            this.confirmSettings = payload;
        },

        resetConfirm() {
            this.confirmSettings = null;
        }
    }
});

export default useModalsStore;